import { useCallback } from "react"
import { appConstants } from "../../appConstants"
import { useHttp } from "../use-http"
import { BSBuildingResult } from "../../dto/beem-shot/BSBuildingResult/BSBuildingResult"

interface BSBuildingHook {
  getAllBSBuildingResult(bsVariantId: string): Promise<BSBuildingResult[]>
}

export function useBSBuildingResult(): BSBuildingHook {
  const { get } = useHttp()

  const getAllBSBuildingResult: (bsVariantId: string) => Promise<BSBuildingResult[]> = useCallback(
    (bsVariantId: string) =>
      get(appConstants.apiEndpoints.BEEM_SHOT_DASHBOARD_BUILDING_RESULT_LIST, [
        { key: "bsVariantId", value: bsVariantId },
      ]).then((response) => response.json()),
    [get]
  )

  return { getAllBSBuildingResult }
}
